import React, { useState } from 'react';
import ArSupported from '../utils/arSupported';

export default function AndroidSmartBanner() {
  const { isAndroid } = ArSupported();
  const [buttonClicked, setButtonClicked] = useState(false);

  const handleClose = () => {
    localStorage.setItem('android_install_banner_closed', true);
    setButtonClicked(true);
  };

  const handleInstall = () => {
    handleClose();
    window.location = "https://play.google.com/store/apps/details?id=com.goyuge.merchant&hl=en&gl=US";
  };

  if (!isAndroid || localStorage?.getItem('android_install_banner_closed') || buttonClicked) return <></>;

  return (
    <div className="w-full flex flex-row items-center h-18 p-2" style={{ background: "#000" }}>
      <div className="col-2 flex flex-row justify-end p-0">
        <img className="w-full" src="/yuge-merchant-app.png" alt="Yuge merchant tool app" />
      </div>
      <div className="col-7 p-2">
        <h2 className="m-0" style={{ fontSize: "1.25rem", color: "rgb(249,250,251)", fontWeight: 100 }}>Yuge Merchant</h2>
        <p className="m-0" style={{ fontSize: "0.875rem", color: "rgb(249,250,251)", fontWeight: 100 }}>Augmented Reality for Webshops</p>
      </div>
      <div className="col-3 p-0">
        <button
          type="button"
          onClick={handleInstall}
          className="w-full m-0 text-white py-2 rounded-full"
          style={{
            background: "rgb(59,130,246)",
            border: "none"
          }}
        >
          OPEN
        </button>
      </div>
    </div>
  );
}
